"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationErrors = void 0;
exports.validationErrors = {
    required: 'Поле обязательно для заполнения',
    minLenght: 'Слишком короткое значение',
    maxLenght: 'Слишком длинное значение',
    incorrect: 'Поле заполнено некорректно',
};
